import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal, {
  ModalHeroImage,
  ModalTitle,
  ModalBody,
  ModalActions
} from '@strava/ui/Modal';
import Button from '@strava/ui/Button';

import I18n from 'utils/I18n';
import createNetworkingClient from 'utils/networking-client';

import polylineImage from './assets/polyline-image.png';
import styles from './styles.scss';

const MapVisModal = ({ experimentVar, paths }) => {
  const units = I18n.measurementUnits();
  const i18nPrefix = `templates.feed.map_visibility_modal.${experimentVar.replace(
    '-',
    '_'
  )}.`;
  const [isOpen, setIsOpen] = useState(true);
  const closeModal = () => setIsOpen(false);

  const setDefaultStreamPrivacy = (value) => {
    createNetworkingClient().put(paths.settingsPath, {
      settings: { default_stream_privacy: value }
    });
  };

  const updateImpressionCapping = () => {
    createNetworkingClient().post(paths.dismissModalPath);
  };

  const handlePrimarySubmit = (e) => {
    e.preventDefault();
    updateImpressionCapping();

    if (experimentVar === 'variant-a') {
      window.location.href = paths.hideAnywherePath;
    } else if (experimentVar === 'variant-b') {
      window.location.href = paths.hideAnywherePath;
    } else if (experimentVar === 'variant-c') {
      window.location.href = paths.articlePath;
    }

    closeModal();
  };

  const handleSecondarySubmit = (e) => {
    e.preventDefault();
    updateImpressionCapping();

    if (experimentVar === 'variant-a') {
      setDefaultStreamPrivacy('meters_200');
    } else if (experimentVar === 'variant-b') {
      setDefaultStreamPrivacy('disabled');
    } else if (experimentVar === 'variant-c') {
      window.location.href = paths.hideAddressPath;
    }

    closeModal();
  };

  const dismissModal = () => {
    updateImpressionCapping();
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={dismissModal}
      hasClose={true}
      className={styles.modal}
      aria-labelledby="map-vis-modal-title"
    >
      <ModalHeroImage
        src={polylineImage}
        alt={I18n.t('templates.feed.map_visibility_modal.modal_image')}
      />
      <ModalTitle className={styles.title} id="map-vis-modal-title">
        {I18n.t(`${i18nPrefix}title`)}
      </ModalTitle>
      <ModalBody>
        <div className={styles.description}>
          {['variant-a', 'variant-b'].includes(experimentVar)
            ? I18n.t(`${i18nPrefix}description_${units}`)
            : I18n.t(`${i18nPrefix}description`)}
        </div>
      </ModalBody>
      <ModalActions style={{ justifyContent: 'space-between' }}>
        <Button
          className={styles.button}
          variant="text"
          type="button"
          onClick={handlePrimarySubmit}
        >
          {I18n.t(`${i18nPrefix}button_primary`)}
        </Button>
        <Button
          className={styles.button}
          variant="primary"
          type="button"
          onClick={handleSecondarySubmit}
        >
          {['variant-a'].includes(experimentVar)
            ? I18n.t(`${i18nPrefix}button_secondary_${units}`)
            : I18n.t(`${i18nPrefix}button_secondary`)}
        </Button>
      </ModalActions>
    </Modal>
  );
};

MapVisModal.propTypes = {
  experimentVar: PropTypes.string.isRequired,
  paths: PropTypes.shape({
    settingsPath: PropTypes.string,
    hideAnywherePath: PropTypes.string,
    hideAddressPath: PropTypes.string,
    articlePath: PropTypes.string,
    dismissModalPath: PropTypes.string
  }).isRequired
};

export default MapVisModal;
